import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    allowEmptyOption: { type: Boolean, default: false },
    maxItems: { type: Number, default: 1 },
    placeholder: String
  }

  connect() {
    if (this.tomSelect) return

    this.tomSelect = new TomSelect(this.element, {
      allowEmptyOption: this.allowEmptyOptionValue,
      create: false,
      maxItems: this.maxItemsValue > 0 ? this.maxItemsValue : null,
      closeAfterSelect: true,
      plugins: this.maxItemsValue > 1 || this.maxItemsValue <= 0 ? ["remove_button"] : [],
      searchField: ["text"],
      placeholder: this.placeholderValue || "",
      render: {
        no_results: (data, escape) => `<div class="px-3 py-2 text-sm text-stone-500">No tenants found for "${escape(data.input)}"</div>`
      }
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
    this.tomSelect = null
  }
}
